import React from 'react';
import { AuthProvider } from '../../context/Auth';
import { NotificationProvider } from '../../context/NotificationContext';
import FuturisticWaitlistManager from './FuturisticWaitlistManager';

const AdminDashboardMinimal: React.FC = () => {
  return (
    <NotificationProvider>
      <AuthProvider>
        <FuturisticWaitlistManager />
      </AuthProvider>
    </NotificationProvider>
  );
};

export default AdminDashboardMinimal;